import React from "react";

interface CertificatePreviewProps {
  name: string;
}

const CertificatePreview: React.FC<CertificatePreviewProps> = ({ name }) => {
  const displayName = name || "<First Last>";

  return (
    <div className="relative bg-[#0b1622] aspect-[1.414/1] w-full p-8 md:p-12 overflow-hidden select-none border border-white/10 shadow-2xl">

      {/* ================= CORNER BORDERS ================= */}
      <div className="absolute top-6 left-6 w-16 h-16 border-l-2 border-t-2 border-[#00d4ff]/80 rounded-tl-xl" />
      <div className="absolute top-6 right-6 w-16 h-16 border-r-2 border-t-2 border-[#00d4ff]/80 rounded-tr-xl" />
      <div className="absolute bottom-6 left-6 w-16 h-16 border-l-2 border-b-2 border-[#00d4ff]/80 rounded-bl-xl" />
      <div className="absolute bottom-6 right-6 w-16 h-16 border-r-2 border-b-2 border-[#00d4ff]/80 rounded-br-xl" />

      {/* ================= TOP HACKATHON LOGO ================= */}
 
      {/* ================= MAIN CONTENT ================= */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center">

        {/* Heading */}
        <div className="mb-8 mt-16">
          <h1 className="text-[#00d4ff] text-5xl md:text-6xl font-extrabold tracking-tight">
            CERTIFICATE
          </h1>
          <p className="text-white/60 tracking-[0.35em] uppercase mt-2 text-sm md:text-base">
            Of Participation
          </p>
        </div>

        <p className="text-white/80 text-lg mb-6">
          This certificate is proudly presented to
        </p>

        {/* Name */}
        <h2 className="text-[#c7ff4d] text-4xl md:text-5xl font-bold italic tracking-wide uppercase mb-8">
          {displayName}
        </h2>

        {/* Description */}
        <p className="max-w-3xl text-white/70 text-sm md:text-base leading-relaxed">
          For successful participation in the{" "}
          <span className="text-[#00d4ff] font-semibold">
            AI for Bharat 2026 Hackathon
          </span>
          , demonstrating innovation, technical excellence, and commitment
          toward building impactful AI solutions.
        </p>

        {/* ================= SPONSOR ================= */}
        <div className="mt-10 flex flex-col items-center gap-3">
          <p className="text-white/40 text-xs tracking-widest uppercase">
            Sponsored By
          </p>

          {/* 👉 PASTE MEERUT CODERS LOGO URL BELOW */}
          <img
            src="https://json.commudle.com/rails/active_storage/representations/proxy/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBLy9YQkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--0f09813e6aa3dc3e732cca755614d3bbadd5bf5f/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdDRG9MWm05eWJXRjBTU0lJY0c1bkJqb0dSVlE2RkhKbGMybDZaVjkwYjE5c2FXMXBkRnNIYVFKQUFXa0NRQUU2QzJ4dllXUmxjbnNHT2dsd1lXZGxNQT09IiwiZXhwIjpudWxsLCJwdXIiOiJ2YXJpYXRpb24ifX0=--e1b8c3103b542b9d7ba47b2862e0d51860fbef22/Screenshot%202025-08-15%20114940.png"
            alt="Meerut Coders Logo"
            className="h-12 object-contain opacity-90"
            crossOrigin="anonymous"
          />

          <p className="text-[#00d4ff] text-sm font-semibold">
            Meerut Coders
          </p>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="absolute bottom-10 left-10 right-10 flex justify-between items-end">

          {/* Signature */}
          <div className="text-left">
            <p
              className="text-[#c7ff4d] text-2xl leading-none"
              style={{ fontFamily: "'Brush Script MT', 'Pacifico', cursive" }}
            >
              Chirag Tankan
            </p><br></br>
            <div className="w-48 h-[1px] bg-[#00d4ff]/60 my-1" />
            <p className="text-[#00d4ff] font-semibold text-sm">
              Chirag Tankan
            </p>
            <p className="text-white/40 text-xs tracking-widest uppercase">
              Organizer
            </p>
          </div>

          <div className="text-right text-white/40 text-xs tracking-widest uppercase">
            Issued • Feb 2026
          </div>

        </div>
      </div>
    </div>
  );
};

export default CertificatePreview; 